export default __webpack_public_path__ + "static/media/cfx-schedule.50bf9547.png";